import { App, Channel } from '@/services/types'
import { BuilderMutations, Profile, SecretKey } from './types'

const mutations: BuilderMutations = {
  setApp(state, app: App | null): void {
    state.app = app
  },
  setAppType(state, appType: string): void {
    state.appType = appType
  },
  setAppCurrencyType(state, appCurrency: string): void {
    state.appCurrency = appCurrency
  },
  setAppSelectedType(state, appSelectedType: string): void {
    state.appSelectedType = appSelectedType
  },
  setProfile(state, profile: Profile): void {
    state.profile = profile
  },
  setChannels(state, channels): void {
    if(Array.isArray(channels)) {
      if(state.channels.length >= 3) {
        state.channels = channels
      } else {
        state.channels = [...state.channels, ...channels]
      }
    } else {
      const test = state.channels
      state.channels = []
      const index = test.findIndex(o => o.id === channels.id)
      state.channels = test
      state.channels[index] = channels
    }
  },
  setPhone(state, phone: string): void {
    state.phone = phone
  },
  setSecretKey(state, secretKey: SecretKey): void {
    state.secretKey = secretKey
  },
  setPromotionalPage(state, payload): void {
    state.promotionalPage = payload
  },
}

export default mutations
